module.exports = __webpack_public_path__ + "media/images/carpenters-img-2-5b0cee29299a9da1ad6c4170c3efbcf6.jpg";